/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-down-purple': {
    width: 16,
    height: 17,
    viewBox: '0 0 16 17',
    data:
      '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M2.36 4.732a1 1 0 011.408.128L8 9.938l4.232-5.078a1 1 0 111.536 1.28l-5 6a1 1 0 01-1.536 0l-5-6a1 1 0 01.128-1.408z" _fill="#A363FF"/>'
  }
})
